import React from 'react';
import { useFormContext } from 'react-hook-form';
import DatePickerField from '../../../calendar/DatePickerField';

const DatesSection = () => {
  const { watch, setValue } = useFormContext();
  
  const pickupDateType = watch('dates.pickupDateType') || 'Exact';
  const deliveryDateType = watch('dates.deliveryDateType') || 'Exact';
  const pickupDateStart = watch('dates.pickupDateStart');
  const pickupDateEnd = watch('dates.pickupDateEnd');
  const deliveryDateStart = watch('dates.deliveryDateStart');
  const deliveryDateEnd = watch('dates.deliveryDateEnd');

  const handlePickupDateTypeChange = (e) => {
    const type = e.target.value;
    setValue('dates.pickupDateType', type, { shouldDirty: true });
    // Clear date fields when switching type
    if (type === 'Exact') {
      setValue('dates.pickupDateStart', '', { shouldDirty: true });
      setValue('dates.pickupDateEnd', '', { shouldDirty: true });
    } else {
      setValue('dates.pickupDate', '', { shouldDirty: true });
    }
  };

  const handleDeliveryDateTypeChange = (e) => {
    const type = e.target.value;
    setValue('dates.deliveryDateType', type, { shouldDirty: true });
    // Clear date fields when switching type
    if (type === 'Exact') {
      setValue('dates.deliveryDateStart', '', { shouldDirty: true });
      setValue('dates.deliveryDateEnd', '', { shouldDirty: true });
    } else {
      setValue('dates.deliveryDate', '', { shouldDirty: true });
    }
  };

  return (
    <div className="dates-section">
      <h3 className="form-section-title">Dates</h3>
      <div className="dates-grid">
        {/* Pickup Date */}
        <div className="dates-row">
          <div className="form-group dates-row__type">
            <label htmlFor="pickupDateType">Pickup Date Type</label>
            <select
              id="pickupDateType"
              value={pickupDateType}
              onChange={handlePickupDateTypeChange}
            >
              <option value="Exact">Exact</option>
              <option value="Estimate">Estimate</option>
            </select>
          </div>
          <div className="dates-row__fields">
            {pickupDateType === 'Exact' ? (
              <div className="form-group">
                <DatePickerField
                  name="dates.pickupDate"
                  label="Pickup Date"
                  placeholder="mm/dd/yyyy"
                />
              </div>
            ) : (
              <>
                <div className="form-group">
                  <DatePickerField
                    name="dates.pickupDateStart"
                    label="Pickup Date Start"
                    placeholder="mm/dd/yyyy"
                  />
                </div>
                <div className="form-group">
                  <DatePickerField
                    name="dates.pickupDateEnd"
                    label="Pickup Date End"
                    placeholder="mm/dd/yyyy"
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {/* Delivery Date */}
        <div className="dates-row">
          <div className="form-group dates-row__type">
            <label htmlFor="deliveryDateType">Delivery Date Type</label>
            <select
              id="deliveryDateType"
              value={deliveryDateType}
              onChange={handleDeliveryDateTypeChange}
            >
              <option value="Exact">Exact</option>
              <option value="Estimate">Estimate</option>
            </select>
          </div>
          <div className="dates-row__fields">
            {deliveryDateType === 'Exact' ? (
              <div className="form-group">
                <DatePickerField
                  name="dates.deliveryDate"
                  label="Delivery Date"
                  placeholder="mm/dd/yyyy"
                />
              </div>
            ) : (
              <>
                <div className="form-group">
                  <DatePickerField
                    name="dates.deliveryDateStart"
                    label="Delivery Date Start"
                    placeholder="mm/dd/yyyy"
                  />
                </div>
                <div className="form-group">
                  <DatePickerField
                    name="dates.deliveryDateEnd"
                    label="Delivery Date End"
                    placeholder="mm/dd/yyyy"
                  />
                </div>
              </>
            )}
          </div>
        </div>
        {/* Pickup/Delivery Rows End */}
      </div>
    </div>
  );
};

export default DatesSection;

